import { useContext } from 'react'
import GithubContext from '../../context/github/GithubContext'

function HomeBackground() {
  const {users, loading} = useContext(GithubContext)

  return (
    <div className='background'>
      <div className={(!loading && users.length <= 0) ? 'shadow-overlay' : 'shadow-overlay-faded'}></div>
    </div>
  )
}

export default HomeBackground
